export var MAX_ORDERS_SHORT = 5;
